import React, { useState } from 'react';

import {
  ReferenceManyField,
  usePermissions,
} from 'react-admin';

import {
  Grid,
  Card,
  CardHeader,
  Divider,
  Box,
  CardContent,
} from '@mui/material';

import { PingListBody } from '../components/ping/PingList';
import RuleVersion from '../components/ping/components/actions/RuleVersion';
import { pingStatusChoices, PingStatuses } from '../constants/pingStatuses';
import SelectInputButton from '../components/layout/inputFields/SelectInputButton';
import Pagination from '../components/layout/Pagination';
import hasAccess from '../utilities/hasAccess';
import actions from '../constants/actions';
import PermissionMissing from '../components/utils/PermissionMissing';

const LatestRelatedPings = ({
  defaultType = 'all',
}: {
  defaultType?: PingStatuses | 'all';
}) => {
  const [status, setStatus] = useState<PingStatuses | 'all'>(defaultType);
  const [versions, setVersions] = useState<string[]>([]);
  const [isTest, setIsTest] = useState<boolean>(false);
  const { permissions } = usePermissions();

  return (
    <Grid size={12}>
      <Card variant="outlined">
        <CardHeader
          title="Related pings"
          action={(
            <Box display="flex" gap={1}>
              <SelectInputButton
                choices={[
                  { id: 'all', name: 'All' },
                  ...pingStatusChoices,
                ]}
                value={status}
                setValue={setStatus}
              />
              {hasAccess(permissions, actions.RULE_VERSION_LIST) && (
                <RuleVersion
                  versions={versions}
                  setVersions={setVersions}
                  isTest={isTest}
                  setIsTest={setIsTest}
                />
              )}
            </Box>
          )}
        />
        <Divider />
        {hasAccess(permissions, actions.PING_LIST) ? (

          <ReferenceManyField
            filter={{ ...(status !== 'all' ? { status } : {}), isTestPing: isTest, ruleVersion: versions }}
            perPage={5}
            pagination={<Pagination disableEmptyText rowsPerPageOptions={[5, 10, 20]} />}
            reference="pings"
            target="entities.id"
            sort={{ field: 'createdAt', order: 'DESC' }}
          >
            <PingListBody />
          </ReferenceManyField>
        ) : (
          <CardContent>
            <Box display="flex" alignItems="center" width="100%" flexDirection="column">
              <PermissionMissing />
            </Box>
          </CardContent>
        )}
      </Card>
    </Grid>
  );
};

export default LatestRelatedPings;
